import { Download, X, FileDown, Eye, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { downloadSampleMart } from "@/lib/sampleMart";

const STEPS = [
  [FileDown, "Export your manifest", "Download tomorrow's trips from MART (DTSV file) or any broker portal as CSV or XLSX."],
  [Eye, "Upload & check the preview", "RideStamp detects MART files automatically and shows every trip, time and fare before anything is saved."],
  [CheckCircle2, "Import and dispatch", "Press Import, then open that day in Trips & Dispatch to assign drivers. Re-uploading the same file never creates duplicates."],
];

export const ImportGuide = ({ onDismiss }) => (
  <div className="mb-6 rounded-xl border border-blue-500/30 bg-blue-500/[0.07] p-5" data-testid="import-guide">
    <div className="flex items-start justify-between gap-3">
      <div>
        <div className="text-xs font-semibold uppercase tracking-wider text-blue-300">First import guide</div>
        <h3 className="mt-1 text-base font-semibold text-white">Get tomorrow's trips into RideStamp in 3 steps</h3>
      </div>
      <button onClick={onDismiss} className="rounded-md p-1 text-slate-400 hover:bg-slate-800 hover:text-white" aria-label="Hide guide" data-testid="import-guide-dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
    <ol className="mt-4 grid gap-3 md:grid-cols-3">
      {STEPS.map(([Icon, title, text], i) => (
        <li key={title} className="rounded-lg border border-slate-800 bg-slate-900/60 p-4" data-testid={`import-guide-step-${i + 1}`}>
          <div className="flex items-center gap-2 text-sm font-semibold text-white">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-600 text-xs">{i + 1}</span>
            <Icon className="h-4 w-4 text-blue-300" /> {title}
          </div>
          <p className="mt-2 text-xs leading-relaxed text-slate-400">{text}</p>
        </li>
      ))}
    </ol>
    <div className="mt-4 flex flex-col gap-3 rounded-lg border border-slate-800 bg-slate-900/40 p-4 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-xs text-slate-300">
        <span className="font-semibold text-white">Want to practice first?</span> Download a sample MART file with 5 made-up trips for tomorrow, upload it below and explore the preview. Press <span className="font-semibold">Start over</span> instead of Import to keep sample trips out of your schedule.
      </p>
      <Button onClick={downloadSampleMart} data-testid="import-guide-download-sample" className="shrink-0 gap-2 bg-blue-700 text-white hover:bg-blue-800">
        <Download className="h-4 w-4" /> Download sample MART file
      </Button>
    </div>
  </div>
);
